import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';
import {services} from '../../../api';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {tr} from '../../../translations';
import {ToastType} from '../../../utils/enums';

/**
 * this function to send email to reset password
 *
 * @param email
 */
export const forgetPassword = async (email: string) => {
  try {
    startLoading();
    await services.auth.forgotPassword(email);
    
    // Show success message
    showGlobalToast({
      message: tr('forgetPassword.successMessage'),
      type: ToastType.SUCCESS,
    });
    
    return {success: true};
  } catch (error: any) {

    const message = error?.response?.data?.error?.message
      ? error?.response?.data?.error?.message
      : tr('app.error');

    return {success: false, message};
  } finally {
    finishLoading();
  }
};
